import styled from 'styled-components';
import { Select as AntSelect } from 'antd';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export const Select = styled(AntSelect)`
  width: 100%;
  font-weight: 500;
`;

export const DropDownIcon = styled(ArrowDropDownIcon)`
  color: ${({ theme }) => theme.colors.grey70};
`;
